import * as actions from './actions';

export default function(store){
    return [...Object.entries(actions)].reduce((all, [key]) => ({
        ...all,
        key: (payload) => store.dispatch(key, payload)
    }), {})
}
